import React from 'react'

function Recordings() {
  return (
    <div>Recordings</div>
  )
}

export default Recordings